import * as actions from './actions';
import { Record } from 'immutable';

const InitialState = Record({
  contactId: undefined,
});
const initialState = new InitialState();

export interface Action {
  type: string;
  payload?: any;
}

export default function appReducer(state = initialState, action: Action) {
  if (!(state instanceof InitialState)) return initialState.mergeDeep(state);

  switch (action.type) {
    case `${actions.FETCH_SALESMANAGO_CONTACT_ID}_SUCCESS`:
      return state.set('contactId', action.payload.contactId);
    case `${actions.FETCH_SALESMANAGO_CONTACT_ID}_ERROR`:
      return state.set('contactId', undefined);
  }

  return state;
}
